import { useMutation } from "react-query";
import { ParametrosAssembleia } from "../typings";
import http from "infra/http";

function useSaveParametrosAssembleia(tenantId: string) {
  return useMutation(
    (data: ParametrosAssembleia) => {
      data.bloquearInadimplente = !data.bloquearInadimplente
      return http.put(`/v1/parametros-votacao/${tenantId}/`, data);
    },
    { retry: false }
  );
}

export default useSaveParametrosAssembleia;
